import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

//Calendar
import calendar from "./calendar/reducer"

// Token validation and route protection
import tokenValidation from "./auth/tokenValidation/reducer"
import routeValidation from "./auth/routeValidation/reducer"
import tokenExpiration from "./auth/tokenExpiration/reducer"
import networkErrorHandling from "./auth/networkErrorHandling/reducer"
import errorDisplay from "./auth/errorDisplay/reducer"
import tokenRenewal from "./auth/tokenRenewal/reducer"
import warningDismissal from "./auth/warningDismissal/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  calendar,
  
  // Token validation and route protection
  tokenValidation,
  routeValidation,
  tokenExpiration,
  networkErrorHandling,
  errorDisplay,
  tokenRenewal,
  warningDismissal,
})

export default rootReducer
